<script>
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({
    components: {}
  })
  export default class PrintHead extends Vue {
    @Prop({
      type: Object, default: () => {
      }
    }) info;


    get gridStyle() {
      return {
        'display': 'grid',
        'grid-template-columns': `30% auto `,
        'grid-template-rows': 'minmax(36px, auto)',
        'gridGap': '12px',
        'justify-content': 'space-around'
      }
    }

    mounted() {
    }

    render(h) {
      const {gridStyle} = this
      return (
        <div>
          <div class="print-head" style={gridStyle}>
            <div style={{
              gridColumnEnd: `span 1`,
              gridRowEnd: `span 4`,
            }}>
              <img src="/static/resources/img/MIX_TY.png" style="width:100%"/>
            </div>
            <div>{`To:`}</div>
            <div>{this.info.vendorName}</div>
            <div>{this.info.vendorAddress}</div>
            <div>{this.info.country}</div>
          </div>
        </div>

      );
    }
  }
</script>

<style scoped lang="scss">
  .print-head >div{
    font-size: 12px;
    font-family: SimSun;
  }
</style>